import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useParams } from "react-router-dom";
import { api } from "../../../../api/apiClient";
import PageHeader from "../../../../app/layout/PageHeader";
import { ServiceDto } from "../../../types/types";
import ServiceRolesCard from "./ServiceRolesCard";
import QualificationTypesCard from "./QualificationTypesCard";

import "../../../../css/buttons.css";
import "../../../../css/cards.css";
import "./ServiceRolesPage.css";

interface RouteParams {
  serviceId: string;
}

export default function ServiceRolesPage() {
  const history = useHistory();
  const { serviceId } = useParams<RouteParams>();
  const serviceIdNumber = Number(serviceId);
  const [service, setService] = useState<ServiceDto | null>(null);

  useEffect(() => {
    api<ServiceDto>(`/api/services/${serviceIdNumber}`).then(setService);
  }, [serviceIdNumber]);

  return (
    <div className="page-container service-roles-page">
      <PageHeader
        title={service?.name ?? "Service"}
        subtitle="Configure roles used for service memberships and rotas."
        actions={
          <div className="service-management-header-actions">
            <button
              type="button"
              className="icon-button-solid"
              title="Back to services"
              aria-label="Back to services"
              onClick={() =>
                history.push(
                  `/admin/manage-services?serviceId=${serviceIdNumber}`,
                )
              }
            >
              <ArrowBackIcon fontSize="small" />
            </button>
          </div>
        }
      />

      <ServiceRolesCard
        key={serviceIdNumber}
        serviceId={serviceIdNumber}
        serviceName={service?.name ?? "Selected service"}
      />
      <QualificationTypesCard />
    </div>
  );
}
